import { useMsal } from '@azure/msal-react'
import { Loader, Stack } from '@mantine/core'
import {
  ConnectAccountManagement,
  ConnectComponentsProvider,
} from '@stripe/react-connect-js'
import { useEffect, useState } from 'react'
import { fetchMyOrganization } from '../../data/organization.service'
import useStripeConnect from '../../hooks/useStripeConnect'
import { OnboardingOrganization } from '../../models/Onboarding/OnboardingOrganization'
import DashboardHeader from './DashboardHeader'

export default function BillingPage() {
  const [organization, setOrganization] =
    useState<OnboardingOrganization | null>(null)
  const { instance } = useMsal()
  const stripeConnectInstance = useStripeConnect(organization?.stripeConnectId)

  useEffect(() => {
    const fetchOrganization = async () => {
      try {
        const org = await fetchMyOrganization(instance)
        setOrganization(org)
      } catch (error) {
        console.error('Error fetching organization:', error)
      }
    }

    fetchOrganization()
  }, [instance])

  if (!organization) {
    return null
  }

  return (
    <Stack>
      <DashboardHeader title='Billing & Banking' />

      <Stack gap='xl' p={24}>
        {stripeConnectInstance ? (
          <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
            <ConnectAccountManagement />
          </ConnectComponentsProvider>
        ) : (
          <Stack align='center' justify='center' h='100%'>
            <Loader size='xl' />
          </Stack>
        )}
      </Stack>
    </Stack>
  )
}
